import FilmCard from "@/components/feature/FilmCard";
import type { Film } from "@/types/content";

interface LatestFilmsProps {
  films: Film[];
}

export default function LatestFilms({ films }: LatestFilmsProps) {
  if (films.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-14 text-center">
        <i className="ri-film-line text-3xl text-background-400" />
        <p className="mt-3 text-sm text-foreground-600">暂无最新影片，敬请期待</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 xl:grid-cols-4">
      {films.map((film) => (
        <FilmCard key={film.id} film={film} />
      ))}
    </div>
  );
}